import { MS_INBOX_TOGGLE_MIA_CHAT_BOT_PATH } from '../../constants/AppConstants';
import fetchWithTimeout from '../../util/fetchWithTimeout';
import { msInboxApiUrl, buildMsInboxAuthHeaders, requireMsApiPlatform } from './msInboxClient';

/**
 * PUT toggle_mia_chatbot contra el microservicio inbox.
 * Habilita/deshabilita las respuestas de MIA de un chat (TikTok / Messenger).
 * Distinto de toggleChatBotMsInbox: ese es el chatbot de flujo clásico
 * (chat_active_bot), este es MIA (customer_mia_chatbot.mia_active).
 * @param {{ id: *, platform: string, enabled: boolean }} payload
 */
export async function toggleMiaChatBotMsInbox(payload) {
  const url = msInboxApiUrl(MS_INBOX_TOGGLE_MIA_CHAT_BOT_PATH);
  const headers = await buildMsInboxAuthHeaders();

  const platform = requireMsApiPlatform(payload?.platform, 'toggle_mia_chatbot');

  const body = {
    id: payload?.id,
    platform,
    enabled: payload?.enabled
  };

  const response = await fetchWithTimeout(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
    mode: 'cors'
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    const errorMessage = errorDetails.message
      || errorDetails.error
      || errorDetails?.errors
      || `HTTP error! Status: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return response.json().catch(() => null);
}
